<div class="container">
  @for(i of [1,2,3,4,5]; track i) {
    <mat-icon
      class="star"
      [ngStyle]="{
        'cursor': readOnly() ? 'default' : 'pointer',
      }"
      [ngClass]="{
        'filled': readOnly() ? stars() >= i : control().value >= i,
        'fill-on-hover': !readOnly(),
      }"
      (click)="!readOnly() && control().setValue(i)"
    >star</mat-icon>
  }
</div>
